import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AiAuthenticationService {
  localstorageAuthorizationKey = 'ai_authorization' as const;
  localstorageRefreshKey = 'ai_refresh_token' as const;
  url = '/api';

  constructor(private http: HttpClient) {}

  refreshToken(): Observable<HttpResponse<any>> {
    return this.http.post(this.url + '/Authorization/Refresh', null, {
      withCredentials: true,
      observe: 'response',
      responseType: 'json',
    });
  }

  setAdminKey(key: string) {
    if (key) {
      window.localStorage.setItem('adminKey', key);
    } else {
      this.clearAdminKey();
    }
  }

  clearAdminKey() {
    window.localStorage.removeItem('adminKey');
  }

  loadAuthorizationFromStorage(): string {
    return window.localStorage.getItem(this.localstorageAuthorizationKey);
  }

  logout() {
    window.localStorage.removeItem(this.localstorageAuthorizationKey);
    window.localStorage.removeItem(this.localstorageRefreshKey);
  }
}
